export default __webpack_public_path__ + "static/media/trash.9f8d875d.svg";